import { createAction } from '../../utils/redux/createAction';
import { consts as SIGN_PRE_VISIT_FORM } from './requests/sign-appointment-consent-req'; // ToDo Rollback!
import { findAndReplace } from '../../utils/arrayModify';

const actionsScope = 'healthboard/appointment-consents-modal';

export const APPOINTMENT_CONSENTS_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const appointmentConsentsModalActions = {
  open: createAction(APPOINTMENT_CONSENTS_MODAL.OPEN),
  close: createAction(APPOINTMENT_CONSENTS_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  organizationName: '',
  serviceName: '',
  startTime: '',
  allConsents: [],
  consent: {},
  isMainConsentView: false,
  urgentVisitFlow: false,
  selfSchedulingFlow: false,
  patientUserInfoId: null,
  rescheduleFlow: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APPOINTMENT_CONSENTS_MODAL.OPEN: {
      const {
        consent,
        allConsents,
        organizationName,
        serviceName,
        startTime,
        isMainConsentView,
        patientUserInfoId,
        urgentVisitFlow,
        selfSchedulingFlow,
        rescheduleFlow,
      } = payload;
      return {
        ...state,
        consent,
        allConsents,
        organizationName,
        serviceName,
        startTime,
        isMainConsentView,
        patientUserInfoId,
        ...(urgentVisitFlow && { urgentVisitFlow }),
        ...(selfSchedulingFlow && { selfSchedulingFlow }),
        ...(rescheduleFlow && { rescheduleFlow }),
        opened: true,
      };
    }

    case APPOINTMENT_CONSENTS_MODAL.CLOSE: {
      return initialState;
    }

    case SIGN_PRE_VISIT_FORM.SUCCEED: {
      const targetConsent = state.allConsents.find(
        ({ id }) => payload.appointmentConsentId === id,
      );
      return {
        ...state,
        consent: {
          ...state.consent,
          accepted: true,
        },
        allConsents: findAndReplace(state.allConsents, {
          ...targetConsent,
          accepted: true,
        }),
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/appointment-consent-modal.js